import { ClassicPreset } from 'rete';
import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { AnyTriggerData } from '../../models/Types/any-trigger-data';
import { NodeEvent } from './node-event';

/**
 * Représente un noeud correspondant à un trigger de workflow.
 */
export class WorkflowTriggerNode extends ClassicPreset.Node {
    public width = 235;
    public height = 85;

    /**
     * Constructeur.
     * @param name : Nom du trigger de workflow.
     * @param type : Type de trigger de workflow.
     * @param workflowActionData : Données du trigger de workflow.
     * @param callBack : Callback appellé pour gérer les évènements du noeud.
     */
    constructor(
        name: string,
        public type: WorkflowTriggerTypes,
        public workflowTriggerData: AnyTriggerData,
        public callBack: (id: string, data: NodeEvent) => void
    ) {
        super(name);
    }
}
